import { useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { useCreateFeedback } from '~/services/feedback/feedback.hooks';

const AI_NOTE_PREFIX = '[AI NOTE] ';

export const AiFeedbackButton = () => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const createFeedback = useCreateFeedback();

  const handleSubmit = async () => {
    if (text.trim().length < 5) {
      message.warning('Please provide more detail.');
      return;
    }

    try {
      await createFeedback.mutateAsync({
        description: `${AI_NOTE_PREFIX}${text.trim()}`,
      });
      message.success('AI note saved');
      setText('');
      setOpen(false);
    } catch {
      message.error('Failed to save note');
    }
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="text-xs border border-black px-3 py-1 hover:bg-black hover:text-white transition-colors"
      >
        AI Note
      </button>

      <Modal
        title="AI Feedback Note"
        open={open}
        onCancel={() => { setOpen(false); setText(''); }}
        footer={null}
        width={500}
        destroyOnClose
      >
        <p className="text-xs text-gray-500 mb-3">
          Leave a note about Oz's behavior — corrections, preferences, or things to improve.
          These are tagged as AI Notes for easy filtering.
        </p>
        <Input.TextArea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={4}
          placeholder="e.g. Oz should always ask about on-site vs warehouse before estimating..."
        />
        <div className="flex justify-end gap-2 mt-3">
          <Button onClick={() => { setOpen(false); setText(''); }}>Cancel</Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            loading={createFeedback.isPending}
            className="!bg-black !border-black !rounded-none"
          >
            Save Note
          </Button>
        </div>
      </Modal>
    </>
  );
};
